app.controller('accountController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', '$timeout', 'meedy.userModel', 'userModel', 'meedy.resourceModel', 'meedy.dictionaryModel', 'meedy.accountingModel', 'nfzOfficeModel', 'ewusModel', 'exportLogEntryModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, $timeout, userModel, edmUserModel, resourceModel, dictionaryModel, accountingModel, nfzOfficeModel, ewusModel, exportLogEntryModel) {

        var listeners = {};

        function listenForExportData() {
            exportLogEntryModel.listenOnExportComplete(function(message, socket) {
                $scope.exportDataObject = JSON.parse(message.body);
                if($scope.exportDataObject.generationStatus === 'COMPLETED') {
                    $scope.alert($scope.T('T.MODULE.SETTINGS.NEW_EXPORT_LOG_DELIVERED'), $scope.T('T.MODULE.SETTINGS.NEW_EXPORT_LOG_DELIVERED_TEXT'), $scope.T('T.UI.APPLICATION.OK'));
                }
            })
        }

        function setData() {

            $scope.forms = {
                ewusAuthForm: null
            };

            $scope.ewusAuthWrapper = new EwusAuthenticationDataWrapper();
            $scope.nfzOfficeList = [];
            $scope.exportDataObject = {};


        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.USER.GET_LOGGED_USER.SUCCESS, function() {
                if(edmUserModel.currentUser.userType === 'DOCTOR') {
                    ewusModel.getEwusAuthenticationDataForDoctor(edmUserModel.currentUser.id).then(listeners.onEwusAuthWrapperLoad);
                }

                exportLogEntryModel.getDataPage({
                    rowsPerSheet: 1,
                    sortColumns: [new EsDataGridSort('exportDate', true)],
                    exportType: Enum.EXPORT_TYPE.OFFICE_DATA,
                    userId: edmUserModel.currentUser.id
                }).then(function(dataPage) {
                    $scope.exportDataObject = dataPage.data[0];
                })
            });

            listeners.onNfzOfficeLoad = function(data) {
                $scope.nfzOfficeList = data.data;
            };

            listeners.onEwusAuthWrapperLoad = function(data) {
                $scope.ewusAuthWrapper = data;
            };

            listeners.onExportPatientDataSuccess = function() {

            }

        }

        function setActions() {
            $scope.updateEwusAuthenticationDataForDoctor = function() {
                $scope.forms.ewusAuthForm.$setSubmitted();
                if($scope.forms.ewusAuthForm.$valid) {
                    ewusModel.updateEwusAuthenticationDataForDoctor(edmUserModel.currentUser.id, $scope.ewusAuthWrapper);
                }
            };

            $scope.downloadExportData = function() {
                exportLogEntryModel.downloadFile($scope.exportDataObject.id)
            };

            $scope.newExportData = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/settings/account/popup/account-export-log-popup.html',
                    controller: 'accountExportLogPopupController'
                }).then(function(data) {
                    $scope.exportDataObject = data;

                    if(data.generationStatus === 'IN_PROGRESS') {
                        listenForExportData();
                    }
                }, function() {

                });
            };

            $scope.hasRightToEditEWUS = function() {
                return edmUserModel.userHasRight(Constant.RIGHT.EWUS_MANAGE_AUTHENTICATION_DATA);
            }
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.ACCOUNT);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            applicationModel.viewReady = true;

            nfzOfficeModel.getDataPage({}).then(listeners.onNfzOfficeLoad);


            if(edmUserModel.currentUser && edmUserModel.currentUser.id) {
                exportLogEntryModel.getDataPage({
                    rowsPerSheet: 1,
                    sortColumns: [new EsDataGridSort('exportDate', true)],
                    exportType: Enum.EXPORT_TYPE.OFFICE_DATA,
                    userId: $scope.isPhysician ? edmUserModel.currentUser.id : edmUserModel.currentUser.doctorIds[0]
                }).then(function(dataPage) {
                    $scope.exportDataObject = dataPage.data[0] || new ExportLogEntryVO();

                    if($scope.exportDataObject.generationStatus === 'IN_PROGRESS') {
                        listenForExportData();
                    }
                })
            }

            listenForExportData();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
